import React from "react";

import { MascotFrame, skinTones } from "./MascotFrame";

export function MorganLeFayArt({ className }: { className?: string }) {
  return (
    <MascotFrame
      className={className}
      backdropClassName="bg-mascot-backdrop-yellow"
    >
      <path
        d="M14 23c0-7.5 4.5-12 10-12s10 4.5 10 12v17c-3 1.5-6.5 2-10 2s-7-.5-10-2z"
        className="fill-gray-800"
      />
      <path
        d="M11 48c0-8.5 5.5-13 13-13s13 4.5 13 13z"
        className="fill-purple-700"
      />
      <path d="M21.5 29v6.6L24 40l2.5-4.4V29z" className={skinTones.medium} />
      <circle cx="24" cy="23" r="6.8" className={skinTones.medium} />
      <path
        d="M17 24c0-6 3-9.5 7-9.5s7 3.5 7 9.5c-1.2-3.5-3.5-5.5-7-6.5-3.5 1-5.8 3-7 6.5z"
        className="fill-gray-800"
      />
      <path
        d="M17.6 18.8c4-1.9 8.8-1.9 12.8 0"
        className="fill-none stroke-yellow-400"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
      <path
        d="M21.4 13.2a2.6 2.6 0 0 0 5.2 0 3.4 3.4 0 0 1-5.2 0z"
        className="fill-yellow-300"
      />
      <circle cx="21.4" cy="23.6" r=".9" className="fill-gray-900" />
      <circle cx="26.6" cy="23.6" r=".9" className="fill-gray-900" />
      <ellipse cx="24" cy="26.9" rx="1.3" ry=".7" className="fill-red-600" />
      <path
        d="M36.5 47v-6"
        className="stroke-yellow-600"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <ellipse cx="36.5" cy="34.5" rx="5" ry="6" className="fill-yellow-500" />
      <ellipse
        cx="36.5"
        cy="34.5"
        rx="3.7"
        ry="4.7"
        className="fill-blue-100"
      />
      <path
        d="M34.6 34a1.9 1.9 0 0 0 3.8 0 2.5 2.5 0 0 1-3.8 0z"
        className="fill-blue-300"
      />
      <path
        d="m34.4 32 1.3-1.3"
        className="stroke-white"
        strokeWidth=".9"
        strokeLinecap="round"
      />
      <circle cx="36.5" cy="41.5" r="1.8" className={skinTones.medium} />
    </MascotFrame>
  );
}
